interface FreeformHashJsonResponse {
  hash: string;
  csrf: {
    name: string;
    value: string;
  };
}

const freeformForms = (): HTMLFormElement[] => [
  ...(<NodeListOf<HTMLFormElement>>(
    document.querySelectorAll("form[data-freeform]")
  )),
];

const fetchFreeformHash = async (
  form: HTMLFormElement
): Promise<FreeformHashJsonResponse> => {
  const response = await fetch(`/api/form?form=${form.dataset.handle}`);
  return await response.json();
};

const hydrateFreeformForm = async (form: HTMLFormElement): Promise<boolean> => {
  const hashResponse = await fetchFreeformHash(form);
  const hashInput = <HTMLInputElement | null>(
    form.querySelector("input[name=formHash]")
  );
  const csrfInput = <HTMLInputElement | null>(
    form.querySelector(`input[name="${hashResponse.csrf.name}"]`)
  );

  if (hashInput === null || csrfInput === null) {
    return false;
  }

  hashInput.value = hashResponse.hash;
  csrfInput.value = hashResponse.csrf.value;

  return true;
};

const freeformCurrentPageIndex = (form: HTMLFormElement): number | null => {
  const currentPageIndexInput = <HTMLInputElement>(
    form.querySelector("input[name=freeformCurrentPageIndex]")
  );

  if (currentPageIndexInput === null) {
    return null;
  }

  return Number(currentPageIndexInput.value);
};

/**
 * Only hydrate a form on its first page. The hash will already be fresh
 * otherwise due to the POST method.
 */
const shouldHydrateForm = (form: HTMLFormElement) =>
  freeformCurrentPageIndex(form) === 0;

freeformForms().filter(shouldHydrateForm).forEach(hydrateFreeformForm);
